import {
  CalendarCheck,
  Award,
  GraduationCap,
  ShieldCheck,
  BookOpen,
  BellRing,
  Quote,
} from "lucide-react";
import { FadeIn, Eyebrow } from "./Reveal";

const FEATURES = [
  { icon: CalendarCheck, label: "Important Exam Dates" },
  { icon: Award, label: "Scholarships and Olympiads" },
  { icon: GraduationCap, label: "Admissions and Counselling Updates" },
  { icon: ShieldCheck, label: "Reliable and Easy to Use" },
  { icon: BookOpen, label: "Useful for Class 6 to 12" },
  { icon: BellRing, label: "Never Miss Any Update" },
];

export default function WhyRecommendSection() {
  return (
    <section
      id="why"
      data-testid="why-recommend-section"
      className="py-16 sm:py-24 lg:py-32"
    >
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
        <FadeIn>
          <Eyebrow index="03" label="Why EduAlert" />
          <h2 className="font-display mt-4 text-3xl font-black tracking-tight text-[#1a237e] sm:text-4xl lg:text-5xl">
            Why Recommend EduAlert?
          </h2>
        </FadeIn>

        <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3 sm:gap-6">
          {FEATURES.map((feature, i) => {
            const Icon = feature.icon;
            return (
              <FadeIn key={feature.label} delay={(i % 3) * 0.08}>
                <div
                  data-testid={`feature-card-${i + 1}`}
                  className="card-hover group flex h-full flex-col gap-5 rounded-3xl border border-[#e2e8f0] bg-white p-7"
                >
                  <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-[#e8eaf6] text-[#1a237e] transition-colors duration-300 group-hover:bg-[#fff3e0] group-hover:text-[#f57c00]">
                    <Icon className="h-6 w-6" />
                  </span>
                  <h3 className="font-display text-lg font-extrabold leading-snug text-[#1a237e]">
                    {feature.label}
                  </h3>
                </div>
              </FadeIn>
            );
          })}
        </div>

        <FadeIn delay={0.15}>
          <div
            data-testid="why-quote"
            className="mt-14 flex max-w-3xl items-start gap-4"
          >
            <Quote className="mt-1 h-8 w-8 shrink-0 text-[#f57c00]" />
            <p className="font-display text-2xl font-bold italic leading-snug text-[#1a237e] sm:text-3xl">
              A small recommendation can make a big difference in a student's
              journey!
            </p>
          </div>
        </FadeIn>
      </div>
    </section>
  );
}